import Footer from "../Footer";
import Navbar from "../Navbar";
import SEO from "../SEO";

const GrievanceRedressalPolicy: React.FC = () => {
    const companyName = import.meta.env.VITE_COMPANY_NAME || "Toofan Loan";
    const companyEmail = import.meta.env.VITE_COMPANY_EMAIL || "support@toofanloan.com";

    const policySections = [
        {
            title: "1. Introduction",
            content: `At ${companyName}, customer satisfaction is our prime focus. We believe in providing the best services to our customers. To ensure that our customers are satisfied, we have a robust Grievance Redressal Mechanism in place.`,
        },
        {
            title: "2. Resolution Mechanism",
            content: "Customers experiencing any issues can reach out via the following levels of escalation:",
            list: [
                `Level 1: Contact our support team via email at ${companyEmail}.`,
                "Level 2: If unresolved within 7 days, escalate to the Grievance Redressal Officer.",
                "Level 3: If the issue remains unresolved after 30 days, customers may appeal to the NBFC Ombudsman at the Reserve Bank of India.",
            ],
        },
        {
            title: "3. Grievance Redressal Officer",
            content: "Our designated Grievance Redressal Officer handles all escalated complaints with a mandated turnaround time.",
            list: [
                "Name: NBFC Grievance Officer",
                `Email: ${companyEmail}`,
                "Turnaround Time: Maximum 30 working days from the date of receipt of the complaint.",
            ],
        },
        {
            title: "4. RBI Ombudsman",
            content: "If you are not satisfied with the resolution provided by our Grievance Redressal Officer, you may escalate your complaint to the Reserve Bank of India (RBI) under the Integrated Ombudsman Scheme.",
        },
    ];

    return (
        <div className="min-h-screen bg-white text-text-primary font-mono selection:bg-secondary selection:text-white">
            <SEO
                title="Grievance Redressal Policy"
                description={`Grievance Redressal Policy and customer complaint resolution mechanism for ${companyName}, a registered NBFC.`}
                keywords={`grievance redressal, complaint resolution, NBFC policy, ${companyName}`}
            />
            <Navbar />

            {/* Official Registry Hero */}
            <section className="w-full bg-text-primary py-32 md:py-48 text-center px-6 relative overflow-hidden border-b-8 border-secondary mb-24">
                <div className="absolute inset-0 opacity-[0.05] pointer-events-none"
                    style={{ backgroundImage: `linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)`, backgroundSize: '40px 40px' }} />

                <div className="relative z-10 max-w-5xl mx-auto">
                    <div className="inline-flex items-center gap-4 px-6 py-2 bg-white/5 border border-white/10 text-secondary text-[10px] font-black uppercase tracking-[0.5em] mb-12">
                        <div className="w-2 h-2 bg-secondary animate-pulse" />
                        Grievance_Redressal_Protocol_v1.0
                    </div>
                    <h1 className="text-5xl md:text-[6rem] font-black tracking-tighter leading-[0.85] mb-12 uppercase text-white italic">
                        Grievance <span className="text-secondary not-italic">Redressal.</span>
                    </h1>
                    <p className="text-white/60 text-lg md:text-2xl max-w-3xl mx-auto font-bold leading-relaxed border-y border-white/10 py-10 uppercase tracking-tight">
                        Customer complaint resolution standards. <br />
                        <span className="text-white">Administered by {companyName} Support.</span>
                    </p>
                </div>
            </section>

            <div className="relative z-10 max-w-5xl mx-auto px-6 lg:px-12 pb-40">
                <div className="border-t-4 border-text-primary">
                    {policySections.map((section, idx) => (
                        <div key={idx} className="border-b border-text-primary/10 py-16 group">
                            <div className="flex flex-col gap-10">
                                <div className="flex items-start gap-8">
                                    <span className="text-secondary font-black text-xs pt-1">SEC_00{idx + 1}</span>
                                    <h2 className="text-3xl md:text-5xl font-black text-text-primary leading-tight uppercase tracking-tighter italic">
                                        {section.title.split('. ')[1] || section.title}
                                    </h2>
                                </div>

                                <div className="pl-16 md:pl-24 space-y-8">
                                    {section.content && (
                                        <div className="text-text-secondary font-bold text-lg leading-relaxed uppercase tracking-tight border-l-4 border-text-primary/5 pl-8 italic">
                                            {section.content}
                                        </div>
                                    )}
                                    {section.list && (
                                        <ul className="space-y-6">
                                            {section.list.map((li, i) => (
                                                <li key={i} className="flex items-start gap-4 text-text-primary font-bold text-base leading-relaxed">
                                                    <div className="w-2 h-2 bg-secondary mt-2 shrink-0" />
                                                    <span className="uppercase tracking-tight">{li}</span>
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default GrievanceRedressalPolicy;
